import React from "react";
import Img from "../../assets/image/index";
import originativeIdeasData from "../../js/originativeIdeasData";
import { OriginativeIdeasCom } from "../../components";
const OriginativeIdeas = () => {
  return (
    <div className="lg:px-5 xl:px-10  xs:px-3 sm:px-6 sm:py-6 m-auto flex justify-center items-start flex-col lg:py-20">
      <div className="w-1/3 xs:w-full xs:mb-2">
        <h2 className="sm:text-lg lg:text-3xl xl:text-4xl uppercase font-unboundedBold lg:leading-10 text-secondary sm:leading-5 sm:mb-2 lg:mb-0">
          Originative about unique ideas.
        </h2>
      </div>
      <div className="flex items-start xs:flex-col">
        <div className="lg:w-1/2">
          <div className="lg:py-5 xs:pb-3 sm:mb-3">
            <p className="text-secondary font-onestLight text-sm lg:text-base lg:leading-5">
              There Are Many Variations Of Passages Of Lorem Ipsum Available,
              But The Majority Have Suffered Alteration In Some Form, By
              Injected Humour, Or Randomised Words Which Don't Look Even
              Slightly Believable. If You Are Going To Use A Passage Of Lorem
              Ipsum,{" "}
            </p>
          </div>
          <div className="xl:pt-5">
            {originativeIdeasData.map((value, index) => {
              return (
                <div key={index} className={`${value.themelayout}`}>
                  <OriginativeIdeasCom
                    themeColor={value.themeColor}
                    title={value.title}
                    dis={value.dis}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className="lg:w-1/2 flex justify-center xs:py-5 items-start">
          {/* <img className="sm:w-10/12 lg:w-11/12 xl:w-9/12 3xl:w-7/12" src={Img.OriginativeImg} alt="" /> */}
          <img
            className="sm:w-10/12 lg:w-11/12 2xl:w-10/12 2xl-wide:w-[75%] 3xl:w-[70%]"
            src={Img.OriginativeImg}
            alt={Img.OriginativeImg}
          />
        </div>
      </div>
    </div>
  );
};
export default OriginativeIdeas;
